<template>
    <div class="bg-white">
        <!-- <Mainlayout></Mainlayout> -->
        <div class="p-2">
            <div style="background-size: cover;">
                <br /><br />
                <div style="width:90%;margin:0 auto">
                    <CRow class="align-items-center justify-content-between mt-4 p-0">
                        <CCol class="d-flex align-items-center">
                            <img :src="user.filePath" class="profile-avatar me-3" />
                            <div class="ml-2">
                                <h3 class="profile-name text-black m-0 custom-12px-400">Welcome</h3>
                                <p class="profile-username m-0 custom-16px-600 text-black">@{{ user.name }}</p>
    
                            </div>
                        </CCol>
                        <CCol class="d-flex align-items-center justify-content-end">
                            <img src="../assets/img/new/smallicon/search.png" width="30px" class="me-2" />
                            <img src="../assets/img/new/smallicon/noti.png" width="30px" class="ml-2" />
                        </CCol>
                    </CRow>
                </div>
            </div>
            <div class="onboarding-container p-2 b-20 mt-3" :style="{ backgroundImage: `url(${bgdiamond})` }" style="width:90%;margin:0 auto;background-size: cover;">
                <h3>Manage reward <br /> redemptions and point <br /> collections in real-time.</h3>
                <br />
                <CButton type="button" class="bg-white border-half">Get Started</CButton>
            </div>
            <div class="w-11/12 mx-auto mt-3" style="width:90%;margin:0 auto;background-size: cover;">
                <CCard class="b-20 border-card p-3">
                    <CRow class="align-items-center">
                        <!-- Text Section -->
                        <CCol xs="6" md="6">
                            <h3 class="custom-16px-500 text-black mb-1">
                                QR Code to Collect Points
                            </h3>
                            <h4 class="custom-12px-400 font-color-9B9B9B">
                                Show this QR Code to customer
                            </h4>
                        </CCol>
    
                        <!-- QR Code Section -->
                        <CCol xs="6" md="4" class="text-md-right text-center mt-2 mt-md-0">
                            <img src="../assets/img/qr.png" class="img-fluid" alt="QR Code" />
                        </CCol>
                    </CRow>
                </CCard>
            </div>
            <div class="w-11/12 mx-auto mt-3" style="width:90%;margin:0 auto;background-size: cover;">
           
                    <CRow class="align-items-center">
                        <!-- Text Section -->
                        <CCol xs="12" md="8">
                            <h3 class="custom-16px-500 text-black mb-1">
                                Pending Request
                            </h3>
                            <h4 class="custom-12px-400 font-color-9B9B9B">
                                Waiting for Approval
                            </h4>
                        </CCol>
    
                        <!-- QR Code Section -->
                        <CCol xs="12" md="4" class="text-md-right text-center mt-2 mt-md-0">
                           <h5 class="font-color-928AFD">See All</h5> 
                        </CCol>
                    </CRow>

                    <CRow>
                        
                    </CRow>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurplerectangle.png";
import bgdiamond from "../assets/img/new/bgdiamond.jpeg";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";
import Footerweb from "../containers/FooterWeb.vue";
import ToggleCard from '../components/Toggle.vue';
import backgroundUrNoArrow from "../assets/img/bgline.png";
import avatar from "@/assets/img/defaultusercartoon.png";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
        Footerweb
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,
            bgdiamond,
            step: 1,
            user: {},
            pend:[]





        };
    },


    async mounted() {
        try {
            // Check if the user is authorized
            const isAuth = await this.UserAuth();

            if (isAuth) {
                // If authenticated, get the user details

                this.GetInfoUser();
                this.GetListPending();
            } else {
            }
        } catch (error) {
            // Handle error, and ensure to redirect if there's an issue
            console.error("Error during authentication:", error);


        }
    },

    methods: {



        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                } else {
                    // Handle failure to get user info if needed
                    console.error("Failed to fetch user info");
                    this.user = {
                        name: "Guest",
                        avatar: "/path/to/default/avatar.jpg",
                        username: "guest",
                        bio: "Welcome to our platform!",
                    };
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                this.user = {
                    name: "Guest",
                    avatar: "/path/to/default/avatar.jpg",
                    username: "guest",
                    bio: "Welcome to our platform!",
                };
            }
        },

        async GetListPending() {
            try {
                const response = await this.$API.get(this.$GetListCompanyCodePointAsyncNotApproved, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.pend = response.data;
                } 
            } catch (error) {
                console.error("Error fetching user information:", error);
               
            }
        },

    }


};
</script>
